// @ts-nocheck
"use client";

import { useEffect, useState } from 'react';
import Link from 'next/link';
import styles from './navbar.module.css';
import { HiArrowLongDown, HiArrowRight } from "react-icons/hi2";
import clsx from 'clsx';
import Slider, { BlogCard } from '../atoms/slider';
import { digest } from '../../utils/slug-builder';
import { vxiContentInterpreter } from '../../utils/vxi-content-interpreter';
import { IoMenuOutline } from 'react-icons/io5';
import { GoDotFill } from 'react-icons/go';
import SearchInput from '../atoms/search-input';
import SearchModal from '../search-modal/search-modal';
import CTABtn from '../atoms/cta-btn';
import { generateHexUrl } from '../../utils/hexes';
import { censorProfanityInline } from '../../utils/profanity-check';

export const Tabs = ({ menus, setOpen, open, toggleOpen, isMobile, darkMode, posts, vxiContent, CXAHub, baseURLenv, token, mostSearched = null, dismissedWordsList = null }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const detailsElement = document.getElementById(digest(menus.menuTitle));
        if (detailsElement) {
            detailsElement.open = open === menus.menuTitle;
        }
    }, [open, menus.menuTitle]);

    const fnCatch = (res) => {
        (res?.input?.trim() === "") ? setOpen("") : setOpen('search');
        setSearchResults(res);
        // console.log("Search Results:", res);
    }

    return (

        menus.menuTitle !== "Thank you" && (<>
            {((menus.subMenus?.[0]?.titles?.length ?? 0) !== 0 ? (
                <>
                    <div className={clsx(styles['tab-item'], { [styles['color-vxi-blaze']]: open !== "" && !darkMode }, { [styles.mobile]: isMobile })} onClick={() => toggleOpen(menus.menuTitle, menus.menuTitle === 'search' && !searchResults?.input?.trim() ? "not searching" : "searching or other")}>
                        {
                            isMobile && open === menus.menuTitle && menus.menuTitle !== "search" ? (<div className="titles-h2-bold">
                                {menus.menuTitle !== 'search' && menus.menuTitle && (
                                    menus.menuTitleURL ? (
                                        <Link href={menus.menuTitle === "Careers" ? "https://jobs.vxi.com/" : `/${menus.menuTitleURL}`} legacyBehavior>
                                            <a target={menus.menuTitle === "Careers" ? "_blank" : undefined} onClick={() => setOpen("")}>
                                                {menus.menuTitle}
                                                <div className={clsx(styles["right-icon"], { [styles.dark]: darkMode })}>
                                                    <HiArrowRight fontSize={18} color={darkMode ? "black" : "white"} />
                                                </div>
                                            </a>
                                        </Link>
                                    ) : (
                                        <div>
                                            {menus.menuTitle}
                                            <div className={clsx(styles["right-icon"], { [styles.dark]: darkMode })}>
                                                <HiArrowRight fontSize={18} color={darkMode ? "black" : "white"} />
                                            </div>
                                        </div>
                                    )
                                )}

                            </div>)
                                : (menus.menuTitle === "search" ?
                                    <div>
                                        <SearchModal fnCatch={fnCatch} referenceList={[]} posts={posts} cxaHubs={CXAHub} vxiContent={vxiContent} tabOpen={open === "search"} isMobile={isMobile} baseUrl={baseURLenv} token={token} mostSearched={mostSearched} loading={loading} setLoading={setLoading} />
                                    </div>
                                    :
                                    <>{menus.menuTitle} <HiArrowLongDown fontSize={15} /></>)
                        }
                    </div>
                    {menus.menuTitle !== "search" || !!searchResults?.input?.trim() ? (
                        <details id={digest(menus.menuTitle)} className={styles.details}>
                            <summary></summary>
                            <TabContents
                                menus={menus}
                                isMobile={isMobile}
                                toggleOpen={toggleOpen}
                                setOpen={setOpen}
                                darkMode={darkMode}
                                searchResults={searchResults}
                                dismissedWordsList={dismissedWordsList}
                                searching={loading}
                            />
                        </details>
                    ) : (
                        null
                    )}
                </>
            ) : (
                <Link href={menus.menuTitle === "Careers" ? "https://jobs.vxi.com/" : `/${menus.menuTitleURL}`} legacyBehavior >
                    <a className={clsx(styles['tab-item'], { [styles['color-vxi-blaze']]: open !== "" && !darkMode })} target={menus.menuTitle === "Careers" ? "_blank" : undefined}>
                        {menus.menuTitle}
                    </a>
                </Link>
            ))}
        </>)
    );
};

const TabContents = ({ menus, isMobile, toggleOpen, setOpen, darkMode, searchResults, dismissedWordsList = null, searching = false }) => {
    const closeTab = () => setOpen && setOpen("");
    return (
        <div className={clsx(styles['tab-content-wrapper'], { [styles.mobile]: isMobile }, { [styles.dark]: darkMode }, { [styles.search]: menus.menuTitle === 'search' })} >
            {menus.menuTitle === "search" ?
                (searchResults?.input !== "" && <div className={clsx(styles['link-wrappers'], { [styles.mobile]: isMobile }, styles["search-results"])}>
                    {searchResults?.input && searchResults?.results?.length !== 0 && <div className={clsx(styles["results-header"], "titles-h2-bold")}>
                        <div><span>Results for&nbsp;</span><i>"{censorProfanityInline(searchResults?.input, dismissedWordsList)}"</i></div>
                        {searchResults?.results?.length && (<small>
                            {(() => {
                                const len = searchResults?.results?.length;
                                if (len < 10) return len;
                                const base = Math.floor(len / 10) * 10;
                                return len % 10 === 0 ? base : `${base}+`;
                            })()} {searchResults?.results?.length === 1 ? "result" : "results"} found.
                        </small>)}
                    </div>}
                    {!searching && searchResults?.input && searchResults?.results?.length === 0 && <div className={clsx(styles["results-header"], "titles-h2-bold")} style={{ gap: 28 }}>
                        <div><span>Looks like we don’t have anything on&nbsp;</span><i>"{censorProfanityInline(searchResults?.input, dismissedWordsList)}"</i><span>&nbsp;just yet.</span></div>
                        <div style={{ fontWeight: 300, fontSize: '15pt', lineHeight: '21pt' }}><span>Let’s change that — reach out and let’s start the conversation.&nbsp;</span></div>
                        <div style={{ lineHeight: '21pt' }}><CTABtn btnName={"Contact Us"} btnURL={"/contact-us"} /></div>
                    </div>}
                    {searching &&
                        <div>
                            Searching...
                        </div>
                    }
                    <div className={styles["search-results-list"]}>
                        {searchResults?.results && searchResults.results
                            ?.filter((res) => {
                                try {
                                    const baseUrl = new URL(res.link).origin;
                                    return baseUrl !== window.location.origin; // Exclude same-origin links
                                } catch {
                                    return true; // Keep relative or invalid URLs
                                }
                            })
                            .map((sr, i) => (
                                i <= 2 &&
                                <Link href={sr.link} key={i} title={sr.title} onClick={closeTab}>
                                    <div className={styles["results-item"]}>
                                        <div className={styles["results-crumbs"]}>{sr.crumbs}</div>
                                        <div className={styles["results-title"]}>{sr.title}</div>
                                        <div className={styles["results-match"]}>
                                            {sr.matchedReferences.map((match, index) => (
                                                <div key={index}>{match}</div>
                                            ))}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        {searchResults?.results?.length > 3 && (
                            <div className={styles["cta-results"]}>
                                <CTABtn btnName="Show all results" btnURL={generateHexUrl(searchResults?.input)} />
                            </div>
                        )}
                    </div>
                </div>)
                :
                (<div className={clsx(styles['link-wrappers'], { [styles.mobile]: isMobile })}>
                    {!isMobile && (
                        <div className={"titles-h2-bold"}>
                            {menus.menuTitle && (
                                menus.menuTitleURL ? (
                                    <Link href={menus.menuTitle === "Careers" ? "https://jobs.vxi.com/" : `/${menus.menuTitleURL}`} legacyBehavior>
                                        <a target={menus.menuTitle === "Careers" ? "_blank" : undefined} onClick={closeTab}>
                                            {menus.menuTitle}
                                            <div className={clsx(styles["right-icon"], { [styles.dark]: darkMode })}>
                                                <HiArrowRight fontSize={18} color={darkMode ? "black" : "white"} />
                                            </div>
                                        </a>
                                    </Link>
                                ) :
                                    <div>
                                        {menus.menuTitle}
                                        <div className={clsx(styles["right-icon"], { [styles.dark]: darkMode })}>
                                            <HiArrowRight fontSize={18} color={darkMode ? "black" : "white"} />
                                        </div>
                                    </div>
                            )}

                        </div>
                    )}
                    <div
                        className={clsx({ [styles.mobile]: isMobile }, styles['link-content-wrappers'])}
                    >
                        {menus.subMenus &&
                            menus.subMenus.map((submenu, index) => (
                                submenu?.titles.length > 0 && (
                                    <div key={index} className={styles['sub-tab']}>
                                        <div>{submenu.subMenuTitle}</div>
                                        <div>
                                            {submenu.titles.map((title, idx) => (
                                                title && (
                                                    <div key={idx} className={styles.link}>
                                                        <Link href={`/${title.url}`} legacyBehavior >
                                                            <a className="upper-title" onClick={closeTab}>{title.title}
                                                                {isMobile && (
                                                                    <GoDotFill size={10} />
                                                                )}
                                                                <p></p>
                                                            </a>
                                                        </Link>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </div>
                                )
                            ))}
                    </div>
                </div>)
            }
            {!isMobile && (
                <div
                    className={clsx(
                        menus.menuTitle === 'search'
                            ? styles['search-wrappers']
                            : styles['slider-wrappers']
                    )}
                >
                    {menus.vxiContent?.map((content, i) => (
                        <div key={i} className={styles['nav-slider']}>
                            <BlogCard place={"menu"} imageList={content.images} vxiContent={content} title={content.title} section={content.section} type={content.type} id={content.id} hubSpotLink={content.hubSpotLink} />
                        </div>
                    ))}
                    {menus.menuTitle === "search" && searchResults?.blogs?.length !== 0 && searchResults?.input !== "" && <div className="titles-h2-bold">You may also like</div>}
                    <div>
                        {menus.menuTitle === "search" && searchResults?.blogs?.length !== 0 && searchResults?.input !== "" && searchResults?.blogs?.map((blog, i) => {
                            const content = vxiContentInterpreter(blog.attributes);
                            return (
                                <div key={i} className={styles['nav-slider']}>
                                    <BlogCard
                                        place="menu"
                                        imageList={content.images}
                                        vxiContent={content}
                                        title={content.title}
                                        section={content.section}
                                        type={content.type}
                                        id={content.id}
                                        hubSpotLink={content.hubSpotLink}
                                    />
                                    {/* <div>{content.title}</div>
                            <div>{content.type}</div>
                            <div>{content.id}</div> */}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

